import { gql } from 'graphql-request';

export const CREATE_ORGANIZATION_DOCUMENT = gql`
  mutation CoreOrganizationDocuments($file: Upload!) {
    coreOrganizationDocuments {
      create(file: $file)
    }
  }
`;
